import AbstractComponent from "./abstract-component";

const createTemplate = (message) => {
  return (
    `<section class="modal">
      <div class="modal__overlay"></div>
      <div class="modal__wrap">
        <button class="modal__closeButton" type="button" title="Закрыть">
          <svg aria-hidden="true" width="16" height="16">
            <use class="" href="sienge/img/sprite.svg#close"></use>
          </svg>
        </button>

        <h2 class="modal__title modal__title--left modal__title--red">Внимание!</h2>
        <p class="modal__text">${message}</p>
      </div>
    </section>`
  );
};


export default class WarningAuthModalComponent extends AbstractComponent {
  constructor({message = ``}) {
    super();

    this._message = message;
  }

  getTemplate() {
    return createTemplate(this._message);
  }

  setShowClass() {
    this.getElement().classList.add(`modal--show`);
  }

  setCloseButtonClickHandler(handler) {
    this.getElement().querySelector(`.modal__closeButton`)
    .addEventListener(`click`, handler);
  }

  setOverlayClickHandler(handler) {
    this.getElement().querySelector(`.modal__overlay`)
    .addEventListener(`click`, handler);
  }
}
